import { render, staticRenderFns } from "./alumni_pdf.vue?vue&type=template&id=af02fbd4&scoped=true&"
import script from "./alumni_pdf.vue?vue&type=script&lang=js&"
export * from "./alumni_pdf.vue?vue&type=script&lang=js&"
import style0 from "./alumni_pdf.vue?vue&type=style&index=0&id=af02fbd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af02fbd4",
  null
  
)

export default component.exports